import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadInformationLogListFailed, loadInformationLogListSuccessful, loadInformationLogListBegin,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import { addFilterQuery } from '../../../utils/addFilterQueryWithCondition';

export default function* loadInformationList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
      sort,
    } = payload;
    let pool = {
      limit,
      page,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool.filter = addFilterQuery(filter);
    }
    if (typeof sort === 'string' && sort.length) {
      pool = { ...pool, sort };
    }

    const url = `${BACKEND_URL}/proxy/backend/api/v2/info/in-requests/search`;
    yield put(loadInformationLogListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const responseData = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadInformationLogListSuccessful(responseData));
      yield call(resolveActionPromise(action, responseData));
    } else {
      yield put(loadInformationLogListFailed());
      yield call(rejectActionPromise(action, responseData));
    }
  } catch (e) {
    yield put(loadInformationLogListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
